<template>
  <v-app>
    <app-bar />
    <v-content>
      <router-view />
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

import AppBar from "@/components/AppBar";
import Footer from "@/components/Footer";

export default {
  name: "App",

  components: {
    AppBar,
    "app-footer": Footer
  },

  data: () => ({
    //
  })
};
</script>
